
import { GROWTH_PATTERNS, SIZES, STAGES } from '../fieldOptions';
import { gridStyle, inputStyle, labelStyle, stepDescStyle } from '../styles';

/**
 * The specimen itself: how big, how many, how far along, and how they grew.
 *
 * Every field is optional, because this is filled in standing over the find
 * rather than at a desk, and a half-answered step is worth more than an
 * abandoned one. Size carries its own "estimated" flag instead of a separate
 * guessed-size field: a measurement and a guess are not the same evidence,
 * and an expert reading the record later needs to know which one this was.
 */
export default function Step3({ t, form, onFormChange }) {
  return (
    <div>
      <p style={stepDescStyle}>{t('step3.desc')}</p>
      <div style={gridStyle}>
        <label style={labelStyle}>
          {t('step3.sizeLabel')}
          <select name="fruiting_body_size" title={t('tip.size')} value={form.fruiting_body_size} onChange={onFormChange} style={inputStyle}>
            <option value="">{t('common:selectPlaceholder')}</option>
            {SIZES.map(s => <option key={s} value={s}>{t(`size.${s}`)} ({t(`sizeHint.${s}`)})</option>)}
          </select>
        </label>
        <label style={{ ...labelStyle, flexDirection: 'row', alignItems: 'center', gap: 6, paddingBottom: 6 }}>
          <input type="checkbox" name="fruiting_body_size_estimated" title={t('tip.sizeEstimated')} checked={form.fruiting_body_size_estimated} onChange={onFormChange} />
          {t('step3.sizeEstimateLabel')}
        </label>
        <label style={labelStyle}>
          {t('step3.stageLabel')}
          <select name="phenological_stage" title={t('tip.stage')} value={form.phenological_stage} onChange={onFormChange} style={inputStyle}>
            <option value="">{t('common:selectPlaceholder')}</option>
            {STAGES.map(s => <option key={s} value={s}>{t(`stage.${s}`)} ({t(`stageHint.${s}`)})</option>)}
          </select>
        </label>
        <label style={labelStyle}>
          {t('step3.countLabel')}
          <input name="fruiting_body_count" title={t('tip.count')} type="number" min="1" step="1"
            value={form.fruiting_body_count} onChange={onFormChange} style={inputStyle} />
        </label>
        <label style={labelStyle}>
          {t('step3.growthPatternLabel')}
          <select name="growth_pattern" title={t('tip.growthPattern')} value={form.growth_pattern} onChange={onFormChange} style={inputStyle}>
            <option value="">{t('common:selectPlaceholder')}</option>
            {GROWTH_PATTERNS.map(g => <option key={g} value={g}>{t(`growthPattern.${g}`)}</option>)}
          </select>
        </label>
      </div>
    </div>
  );
}
